import React, { useState, useContext } from 'react';
import TextField from '@mui/material/TextField';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import { CommonContext } from '../../../context';
import commonApi from '../../../utils/api';
import { Card, CardContent, Grid } from '@mui/material';

const ChangePassword = () => {
    const { user, setIsLoading, setOpenAlert, setAlertMessage, setSeverity, rowData } = useContext(CommonContext)
    // const { rowData } = useContext(MerchantContext);
    const [formErrors, setFormErrors] = useState({});
    const [formData, setFormData] = useState({
        new_password: '',
        confirmPassword: '',
    });
    const handleChange = (event) => {
        const { name, value, type } = event.target;
        setFormData((prevData) => ({
            ...prevData,
            [name]: type === 'file' ? event.target.files[0] : value,
        }));
    };
    const handleChangePassword = (e) => {
        e.preventDefault();
        const errors = {};
        if (!formData?.new_password) {
            errors.new_password = 'New Password is required';
        } else if (formData.new_password.length < 6) {
            errors.new_password = 'Password must be at least 6 characters long';
        }
        if (!formData?.confirmPassword) {
            errors.confirmPassword = 'Confirm Password is required';
        } else if (formData.new_password !== formData.confirmPassword) {
            errors.confirmPassword = 'Passwords do not match';
        }
        setFormErrors(errors);
        if (Object.keys(errors).length === 0) {
            if (user?.user_type === "Merchant") {
                formData.merchant_id = user?.id
            } else {
                formData.merchant_id = rowData?.id
            }
            setIsLoading(true);
            const url = '/merchant/change-password';
            commonApi.post(url, formData)
                .then((response) => {
                    setIsLoading(false);
                    setOpenAlert(true);
                    if (response.data.s === 1) {
                        setAlertMessage(response?.data?.msg);
                        setSeverity('success');
                    } else {
                        setAlertMessage(response?.data?.msg);
                        setSeverity('error')
                    }
                }).catch((error) => {
                    setOpenAlert(true);
                    setAlertMessage(error?.response?.data?.msg);
                    setSeverity('error')
                    setIsLoading(false);
                });
        }

    };
    return (
        <Box className="common-form-container">
            <form className="common-form-data" onSubmit={handleChangePassword}>
                <Card className="form-section">
                    <CardContent>
                        <Grid container spacing={2}>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    label="New Password"
                                    type="password"
                                    name="new_password"
                                    defaultValue={formData?.new_password}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    // margin="normal"
                                    error={!!formErrors.new_password}
                                    helperText={formErrors.new_password}
                                />
                            </Grid>
                            <Grid item size={{ xs: 12, md: 6 }}>
                                <TextField
                                    label="Confirm New Password"
                                    type="password"
                                    name="confirmPassword"
                                    defaultValue={formData?.confirmPassword}
                                    onChange={handleChange}
                                    fullWidth
                                    size="small"
                                    // margin="normal"
                                    error={!!formErrors.confirmPassword}
                                    helperText={formErrors.confirmPassword}
                                />
                            </Grid>

                            <Grid item size={{ xs: 12, md: 12 }} sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                <Button variant="contained" color="primary" type="submit">
                                    Submit
                                </Button>
                            </Grid>
                        </Grid>
                    </CardContent>
                </Card>
            </form>
        </Box>
    );
};

export default ChangePassword;
